// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__Ir-Zg","validationTips":"StatementDescriptor_validationTips__bknXa"};